let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("77dzh")).then(() => parcelRequire('eBV1M'));